import React from 'react';
import MapObjectRenderer from '@components/game/objects/MapObjectRenderer';
import classnames from 'classnames';
import { CONFIG } from '@utils/constants';
import './TerrainTile.css';

export default function TerrainTile({
  x,
  y,
  terrain,
}) {
  
  const showCoordinates = CONFIG.SHOW_COORD;
  const tileClasses = classnames('map-tile', `terrain-${terrain}`);
  
  return (
    // 👇 1. Eliminamos el onClick de este div
    <div className={tileClasses}>
      {showCoordinates && (
        <div className="tile-coordinates">
          ({x}, {y})
        </div>
      )}
    </div>
  );
}